module.exports = __webpack_public_path__ + "static/in-defense-of-food-c1bfd37d66ebc7385006c7d6db85fc0e.jpg";